import { 
  getPlaylist,
  deletePlaylist,
  getPlaylistVideosList,
  postVideo,
  updatePlaylist,
  postClassPersonelPlaylist,
  getSuggestedPlaylist
     } from "@/services/playlist.service";
import { setPaginationDetails } from "../../utils/utils";

const state = () => ({
  playlistModel: {},

  playlistvideosListModel: {},
  playlistid: null,

  selectedVideos: [],
});

const mutations = {
  setPlaylistModel(state, data) {
    state.playlistModel = data;
  },

  setplaylistvideosListModel(state, data) {
    state.playlistvideosListModel = data;
  },

  setSelectedVideos(state, data) {
    state.selectedVideos = data;
  },
};

const actions = {

    async loadPlaylist(vuexContext, co) {    
        return await getPlaylist(co).then((response) => {
          let data = response.data.data;
          let items = data.items;
          let totalCount = data.totalCount;
          let totalPages = data.totalPages;
    
          items.map((item, index) => {
            item.index = index + 1;
            item.Name = item.name;
          });
    
          setPaginationDetails(co, totalCount, totalPages);
    
          return items;
        });
      },  

      async loadSuggestedPlaylist() {    
        return await getSuggestedPlaylist().then((response) => {
          let data = response.data.data;
    
          return data;
        });
      },  

      addPlaylistModel(vuexContext, data) {
        vuexContext.commit("setPlaylistModel", data);
      },

      async deletePlaylist(vuexContext, data) {
        return await deletePlaylist(data).then((response) => {
          let data = response;
          return data;
        });
      },

      async loadPlaylistVideoList(vuexContext, playlistid) {

          return await getPlaylistVideosList(playlistid).then((response) => {
            let data = response.data.data;
            let items = data.items;
      
            items.map((item, index) => {
              item.index = index + 1;
            });
            return items;
          });
      },  

      addplaylistvideosListModel(vuexContext, data) {
          vuexContext.commit("setplaylistvideosListModel", data);
      },

      addSelectedVideos(vuexContext, data) {
          vuexContext.commit("setSelectedVideos", data);
      },
        
      async postPlaylist(vuexContext, data) {
        return await postVideo(data).then((response) => {
          let data = response;
          return data;
        });
      },

      async updatePlaylist(vuexContext, data) {
        return await updatePlaylist(data).then((response) => {
          let data = response;
          return data;
        });
      },

      async postClassPersonelPlaylist(vuexContext, data) {
        return await postClassPersonelPlaylist(data).then((response) => {
          let data = response;
          return data;
        });
      },

  };

  const getters = {

  };

  export default {
      namespaced: true,
      state,
      getters,
      actions,
      mutations,

  };